<template>
  <div>
    <div v-if="partnerText">
      <p class="footer-title">{{ partnerText }}</p>
    </div>
    <div class="footer-info__btn-wrapper">
      <a
        class="footer-btn transparent-btn"
        :href="partnerLinkUrl"
        data-google-interstitial="false"
        data-dl_location="footer"
        :data-dl-subscription-params="getSubscriptionParams()"
      >
        {{ partnerLinkText }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'edi-footer-info',
  props: {
    text: String,
    link: Object,
  },
  computed: {
    ...mapGetters([
      'isLogged',
      'isPartner',
    ]),
  },
  data() {
    return {
      hasText: false,
      partnerText: '',
      partnerLinkText: '',
      partnerLinkUrl: '',
    };
  },
  methods: {
    async init() {
      if (this.isLogged
        && this.isPartner
      ) {
        this.partnerText = 'Gracias. Tu apoyo nos permite seguir investigando y hacer periodismo de calidad';
        this.partnerLinkText = 'AUMENTA TU CUOTA';
        this.partnerLinkUrl = 'https://usuarios.infolibre.es/perfil/cuota/';
      } else {
        this.partnerText = this.text;
        this.partnerLinkText = this.link.text;
        this.partnerLinkUrl = this.link.url;
      }
    },
    getSubscriptionParams() {
      let params = JSON.stringify({
        im_location: 'footer',
        im_type: 'infoLibre',
      });
      if (this.isLogged
        && this.isPartner) {
        params = JSON.stringify({ im_location: 'footer' });
      }
      return params;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
